/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1664
 */

var r = require(/* 86 */"./1650/86/index")
var /* [auto-meaningful-name] */require_1263_$_1683_1263$entries = require(/* 1263 */"./1683/1263").entries
r({
  target: "Object",
  stat: true
}, {
  entries: function (e) {
    return require_1263_$_1683_1263$entries(e)
  }
})
